import * as types from './mutation-types'
import { api } from '../apic'
import { communicate, httpPromise } from '../utils'
import router from '@/route'

//vuex的action  包含异步逻辑 可以提交mutation

//保存用户信息
export const saveUser = ({ dispatch, commit, state }, { auth, auth2, name = '', userId = '' }) => {
  //localStorage.setItem("currentUser_name",name);
  localStorage.setItem('auth', auth)
  localStorage.setItem('auth2', auth2)

  head.auth = auth
  head.auth2 = auth2

  if (eventHub) {
    eventHub.$emit('authReady')
  }

  commit(types.SET_USER, { auth, auth2, name, userId })

  // dispatch('getUserInfo')
}

//获得用户信息 promise方式
export const getUserInfo = ({ dispatch, commit, state }) => {
  // console.log(9999999)

  const apiurl = api.getUserInfoDiff.apiurl
  const postData = api.getUserInfoDiff.postData
  postData.head.auth = state.user.auth
  // postData.head.auth = "RF2YOIPuZ38Vfjx16ly9VtDOEPBY7RjpwEs0vlJ051U=";

  if (!state.user.auth && !head.auth) {
    return
  }

  communicate(apiurl, postData, function(res) {
    var { basic: { level, userId, name, gender, realName, email ,type} } = res.body
    var userType = type
    delete res.body.responseStatus
    commit(types.SAVE_USERINFO, { level, name, userId, userType, gender, realName, email })
    commit(types.SAVE_USERINFOALL, res.body)

    //同步用户信息到认证信息
    let title = ''
    switch (userType) {
      case 1 : {
        title = '医务工作者'
        break
      }
      case 2 : {
        title = '企业人士'
        break
      }
      case 3 : {
        title = '患者及家属'
        break
      }
      case 4 : {
        title = '其他'
        break
      }
      case 5 : {
        title = '在校学生'
        break
      }
      case 6 : {
        title = '科研教育'
        break
      }
      default : {
        title = '医务工作者'
      }
    }

    commit('UPDATE_MESSAGE', {
      type: 'userType',
      val: userType
    })

    //v8.7 h5登陆简化，移除选择身份&完善信息。提交认证增加身份选择强校验
    // if (state.userInfo.userType == 0 && !IsPC()) {
    //   router.push({ name: 'UserType' })
    // }

    // console.log('router.history.current.fullPath', router.history.current.fullPath)

    //特定路由 显示完善信息
    // 1、微站主页
    // 2、公开课列表
    // 3、专栏列表
    // 4、专题列表
    if(is_weixin() || is_app()){
      if (router.history.current.fullPath == '/' || router.history.current.fullPath == '/Index' || router.history.current.fullPath == '/liveList' || router.history.current.fullPath == '/columnList56' || router.history.current.fullPath == '/subjectList' || (!is_weixin() && !is_app())) {
        //判断用户信息是否完善
        const apiurlcom = api.checkInfoComplete.apiurl
        const postDatacom = api.checkInfoComplete.postData
        postData.head.auth = state.user.auth
        communicate(apiurlcom, postDatacom, function(res) {
          //记录用户登录信息是否完善
          commit(types.SAVE_ISCOMPLETE, res.body.isComplete)
          console.log(res.body.isComplete)
          commit(types.SAVE_onlyLackDisease, res.body.onlyLackDisease)
          // level 0： 1：未认证 2：已认证 3：未通过 4：审核中
          /**  v8.7 h5登陆简化，移除选择身份&完善信息。提交认证增加身份选择强校验
          location.href ='#'+state.completepath
          if (!parseInt(res.body.isComplete) && router.history.current.fullPath != '/identify/PersonalInfo/complete') {
            //记录如果用户信息不完善跳转完善页后返回的页面路由
            if (res.body.onlyLackDisease) {
              commit(types.SAVE_COMPLETEPATH, router.history.current.fullPath)
              setTimeout(() => {
                router.push({ path: '/identify/AuthDisease' })
              }, 800)

            } else {
              commit(types.SAVE_COMPLETEPATH, router.history.current.fullPath)
              setTimeout(() => {
                router.push({ path: '/identify/PersonalInfo/complete' })
              }, 800)

            }
          } */
        })
      }
    }

  })
}

//获得用户信息
export const getUserInfoPromise = ({ dispatch, commit, state }) => {

  const apiurl = api.getUserInfoDiff.apiurl
  const postData = api.getUserInfoDiff.postData
  postData.head.auth = state.user.auth

  if (!state.user.auth && !head.auth) {
    return
  }

  return new Promise((resolve, reject) => {
    httpPromise(apiurl, postData).then(res => {
      var { basic: { level, userId, name, gender, realName, email, type} } = res.body
      var userType = type

      delete res.body.responseStatus

      commit(types.SAVE_USERINFO, { level, name, userType, gender, realName, email })
      commit(types.SAVE_USERINFOALL, res.body)
      resolve(res)
    }, err => {
      reject(err)
    })
  })
}


//上传认证信息 设置用户企业信息
export const uploadAuthInfo = (context, data) => {

  var auth = ''
  //上传认证信息
  const handler = function(resolve, reject) {
    //判断用户身份 提交信息
    const apiurl = api.uploadIdcardsTwo.apiurl

    const postData = {
      'head': {
        'auth': '',
        'auth2': '',
        'cid': '861010035174520',
        'cver': '7.1',
        'patientToken': null
      }
    }

    // 埋点相关----H5部分
    let burPoints = {}
    // page_source ____ 1.我的任务页 2.福利活动页  3.内容详情页 4.商品详情页 5.其他
    if (context.state.completepath.match('/NewcomerWelfare')) {
      burPoints.page_source = 2
    } else if (context.state.completepath.match('/doc')) {
      burPoints.page_source = 3
    } else if (context.state.completepath.match('/live')) {
      burPoints.page_source = 3
    } else if (context.state.completepath.match('/CreditMallPage')) {
      burPoints.page_source = 4
    } else if (context.state.completepath.match('/CreditMallProcuctDetail')) {
      burPoints.page_source = 4
    } else if (context.state.completepath.match('/2022under35')) {
      burPoints.page_source = 7
    } else if (context.state.completepath.match('/2022under35Detail')) {
      burPoints.page_source = 7
    } else {
      burPoints.page_source = 5
    }

    // page_name ____ 1.完善信息页  2.个人设置页  3.实名认证页 4.其他
    if (router.history.current.fullPath.match('/jurisdictionInfo')) {
      burPoints.page_name = 1
    } else if (router.history.current.fullPath.match('/rztwo')) {
      burPoints.page_name = 3
    } else if (router.history.current.fullPath.match('/AuthDisease')) { // 只擅长瘤种-不埋
    } else if (router.history.current.fullPath.match('/personalInfo')) {
      burPoints.page_name = 2
    } else if (router.history.current.fullPath.match('/UploadIdcard')) {
      burPoints.page_name = 3
    } else if (router.history.current.fullPath.match('/jurisdictionDisease')) { // 只擅长瘤种-不埋
    } else {
      burPoints.page_name = 4
    }
    postData.buriedPoints = [
      {
        propertiesMap: burPoints,
        eventName: 'InformationImprove'
      }
    ]
    console.log('currentpath_', router.history.current.fullPath)
    console.log('previouspath_', context.state.completepath)
    console.log('context,context,context，context，context1111', context.state)
    console.log('contextpostData', context.state)
    const ddata = context.state.authInfo
    const iscomplete = context.state.iscomplete
    const onlyLackDisease = context.state.onlyLackDisease

    // onlyLackDisease
    for (const i in ddata) {
      postData[i] = ddata[i]
    }
    //判断学生
    if (context.state.authInfo.userType == 2) {
      //不是医生
      // postData.hospital = "医院";
      //科室和职称 在其他身份下 选为为选择
      postData.department = 0
      // postData.departmentStr = "中国医疗大学";
      postData.title = 0

      postData.degree = 0
      // postData.titleStr = "挖掘机和钻研";
    }

    if (context.state.authInfo.userType == 6) {
      postData.title = 0
      postData.department = 0
      postData.hospitalId = 0
    }

    if (context.state.authInfo.userType == 1) {
      postData.prov = ''
      postData.provId = ''
      postData.city = ''
      postData.cityId = ''
      postData.degree = ''
    }

    if (!iscomplete) {
      // postData.ignoreCertificate = 1
      if (!onlyLackDisease) {
        postData.infoSources = 1
      }
    } else {
      // postData.ignoreCertificate = 0
    }
    if(router.history.current.fullPath == '/identify/rztwo'){
      postData.ignoreCertificate = 0
    }else{
      postData.ignoreCertificate = 1
    }

    auth = postData.head.auth
    console.log('uploadIdcardsTwopostData', postData)
    httpPromise(apiurl, postData).then(res => {
      //重置userInfo
      // context.dispatch('getUserInfo');
      resolve(res)
    }, err => {
      reject(err)
    })

  }

  const setuserenterprise = function(resolve, reject) {
    //判断用户身份 提交信息
    const apiurl = Global_apiserver + 'api/enterprise/setuserenterprise'

    const postData = {
      'head': {
        'auth': '',
        'auth2': '',
        'cid': '861010035174520',
        'cver': '7.1',
        'patientToken': null
      },
      id: 0
    }
    const id = context.state.authInfo.hospitalId
    postData.id = id
    postData.head.auth = auth

    console.log('setuserenterprisepostData', postData)

    httpPromise(apiurl, postData).then(res => {
      resolve(res)
    }, err => {
      reject(err)
    })

  }

  return new Promise((resolve, reject) => {
    handler(resolve, reject)
    if (context.state.userInfo.userType == 2) {
      setTimeout(() => {
        setuserenterprise(resolve, reject)
      }, 500)
    }
  })
}

// 同步用户身份
export const syncUserType = (context, data) => {

  const apiurl = api.choicerole.apiurl
  const postData = api.choicerole.postData
  postData.roleType = context.state.userInfo.userType
  postData.head.auth = head.auth

  return new Promise((resolve, reject) => {
    httpPromise(apiurl, postData).then(res => {
      //重置userInfo
      context.dispatch('getUserInfo')
      resolve(res)
    }, err => {
      reject(err)
    })
  })


}

//提交认证信息
export const syncAuthInfo = (context, data) => {

  let userInfo = context.state.userInfo

  // 身份
  let userType = userInfo.userType

  // 用户id
  let userId = userInfo.basic.userId

  // 擅长瘤种
  let diseases = userInfo.diseases

  // 具体身份
  let typeChild = userInfo.typeChild

  //真实姓名 -> name
  let name = userInfo.basic.realName

  // 所在地区
  let prov = userInfo.basic.prov
  let provId = userInfo.basic.provId
  let city = userInfo.basic.city
  let cityId = userInfo.basic.cityId

  let email = userInfo.basic.email

  // let professional = userInfo.professional;


  //所在医院 -> department
  let hospital = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].companyName
  hospital = hospital ? hospital : ''
  let hospitalId = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].companyId
  hospitalId = hospitalId ? hospitalId : 0

  //所在单位 -> departmentStr
  let deptName = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptName
  deptName = deptName ? deptName : ''
  //医生所在科室
  let deptId = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptId
  deptId = deptId ? deptId : ''

  //学校 -> universityName
  let universityName = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].universityName
  universityName = universityName ? universityName : ''

  // 入学年份
  let enrollmentYear = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].enrollYear
  enrollmentYear = enrollmentYear ? enrollmentYear : ''

  // 学历
  let degree = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].degree
  degree = degree ? degree : ''

  //专业 -> majorId
  let majorId = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].majorId
  majorId = majorId ? majorId : ''
  let majorName = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].majorName
  majorName = majorName ? majorName : ''

  //部门职称 -> titleStr
  let deptTitle = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptTitle
  deptTitle = deptTitle ? deptTitle : ''
  //医生职称 -> title int
  let deptTitleId = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptTitleId
  deptTitleId = deptTitleId ? deptTitleId : ''

  const state = {
    userType,
    userId,
    typeChild,
    diseases,
    prov,
    provId,
    city,
    cityId,
    name,
    degree,
    departmentStr: deptName,
    department: deptId,
    hospital,
    hospitalId,
    universityName,
    majorId,
    majorName,
    titleStr: deptTitle,
    title: deptTitleId,
    email: email,
    enrollmentYear
  }


  context.commit('SYNC_AUTHINFO', state)
}

// 同步更新个人信息
export const syncPersonalinfo = (context, data) => {
  let userInfo = context.state.userInfo
  let diseases = userInfo.diseases
  let userId = userInfo.basic.userId
  let sequenceId = userInfo.professional && userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].sequenceId || ''
  let EsequenceId = userInfo.professional && userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].sequenceId || ''

  let level = userInfo.basic.level || 0
  let headPortraitUrl = userInfo.basic.headPortraitUrl || ''
  let name = userInfo.basic.name || ''
  let gender = userInfo.basic.gender || 0
  let mobile = userInfo.basic.mobile || ''
  let email = userInfo.basic.email || ''
  let introduction = userInfo.basic.introduction || ''
  let userType = userInfo.userType || 0 //0 还未选择身份
  let typeChild = userInfo.typeChild || '' //0 还未选择具体身份
  let realName = userInfo.basic.realName || 0 //0 还未选择身份
  let prov = userInfo.basic.prov || ''
  let provId = userInfo.basic.provId || ''
  let city = userInfo.basic.city || ''
  let cityId = userInfo.basic.cityId || ''


  let degree = userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].degree || ''
  let enrollYear = userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].enrollYear || ''

  let universityName = userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].universityName || ''

  let majorId = userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].majorId || ''  //专业
  let majorName = userInfo.professional.educations && userInfo.professional.educations[0] && userInfo.professional.educations[0].majorName || ''  //专业

  let companyName = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].companyName || ''
  let companyId = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].companyId || ''
  let deptName = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptName || ''  //科室, 部门
  let deptId = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptId || ''  //科室ID
  let deptTitleId = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptTitleId || ''  //医院职称ID
  let deptTitle = userInfo.professional.companies && userInfo.professional.companies[0] && userInfo.professional.companies[0].deptTitle || ''  //企业职称

  const state = {
    sequenceId,
    EsequenceId,
    level,
    headPortraitUrl,
    name,
    gender,
    mobile,
    email,
    introduction,
    userType,
    typeChild,
    realName,
    prov,
    provId,
    city,
    cityId,
    universityName,
    companyId,
    companyName,
    degree,
    enrollYear,
    majorId,
    majorName,
    deptId,
    deptName,
    deptTitleId,
    deptTitle,
    diseases,
    userId
  }

  context.commit('SYNC_PRESONALINFO', state)

}

//获得EDC用户信息
export const getEDCUserInfoPromise = ({ dispatch, commit, state }) => {


  var apiurl = Global_apiserver + 'api/edc/user/getCert'
  const postData = {
    'head': {
      'auth': '',
      'auth2': '',
      'cid': '861010035174520',
      'cver': '7.7',
      'patientToken': null
    }
  }

  postData.head.auth = state.user.auth
  // postData.head.auth = 'VPnBTONCwmFWl2Jiwudn8Scy+fXt+8klktt48qRbmd8='
  // postData.head.auth2 = 'kLiaLVd1YqpdtUYWRgeKYQ=='

  return new Promise((resolve, reject) => {
    httpPromise(apiurl, postData).then(res => {
      if (res && res.body && res.body.responseStatus && res.body.responseStatus.ack == 0 && res.body.data && res.body.data.obj) {
        //用户非第一次进行科研认证
        var data = res.body.data.obj

        const state = {
          id: data.id,
          name: data.realName || '',
          idCardNum: data.idNo,
          hospital: data.hospital,
          hospitalId: data.hospitalId,
          departmentId: data.departmentId,
          departmentStr: data.department,
          province: data.prov,
          provinceId: data.provId,
          city: data.city,
          cityId: data.cityId,
          idCardFrontUrl: data.idCardFrontUrl,
          idCardFrontKey: data.idCardFront,
          idCardBackUrl: data.idCardBackUrl,
          idCardBackKey: data.idCardBack,
          bankInfo: {
            name: data.accountBank,
            number: data.accountCard,
            province: data.bankProv,
            provinceId: data.bankProvId,
            city: data.bankCity,
            cityId: data.bankCityId
          },
          doctorLicenceUrl: data.physicianLicenseUrl,
          doctorLicenceKey: data.physicianLicense,
          otherDataKeys: data.otherDataKeys,
          otherDataUrls: data.otherDataUrls
        }

        commit(types.SAVE_EDCDOCTORINFO, state)
        resolve(res)

      } else {
        //用户第一次进入科研认证，直接拿APP的用户信息直接展示
        apiurl = api.getUserInfoDiff.apiurl
        let postUserInfoData = {
          head,
          pro:"1"
        }
        httpPromise(apiurl, postUserInfoData).then(res => {
          if (res && res.body && res.body.responseStatus && res.body.responseStatus.ack == 0 && res.body) {
            var data = res.body
            const state = {
              name: data.basic.realName || '',
              idCardNum:  data.basic.idCard || '',
              hospital: data.professional.companies[0].companyName,
              hospitalId: data.professional.companies[0].companyId,
              departmentId: data.professional.companies[0].deptId,
              departmentStr: data.professional.companies[0].deptName,
              province: data.basic.prov,
              provinceId: data.basic.provId,
              city: data.basic.city,
              cityId: data.basic.cityId
            }

            console.log(state)
            commit(types.SAVE_EDCDOCTORINFO, state)
            resolve(res)
          }
        })
      }

    }, err => {
      reject(err)
    })
  })
}

//获得互联网医院申请入驻的用户信息
export const getIHApplyUserInfoPromise = ({ dispatch, commit, state }, { centerId }) => {

  var apiurl = Global_apiserver + 'api/dhDoctorApplication/repeatCheck'
  const postData = {
    'head': {
      'auth': '',
      'auth2': '',
      'cid': '861010035174520',
      'cver': '7.8',
      'patientToken': null
    },
    medicalId: centerId//单病种中心的id
  }

  postData.head.auth = state.user.auth
  // postData.head.auth = 'K+5S2lYC7akupHch7IGLLu2WcvWWUHhCyW+gii2Zk0E='
  // postData.head.auth2 = 'MV2Pm0VwxMobxnuWI720Qg=='

  return new Promise((resolve, reject) => {
    httpPromise(apiurl, postData).then(res => {
      if (res && res.body
        && res.body.responseStatus
        && res.body.responseStatus.ack == 0
        && res.body.dhDoctorApplication) {

        var data = res.body.dhDoctorApplication


        var attachments = res.body.attachments

        var picSec = [[undefined,undefined],[undefined,undefined],[undefined,undefined],[undefined]]//证件照分类(数组的元素从前往后依次是：身份证(正反面)、医师资格证（第一第二页）、执业证（第一第二页）、医师职称（第一页）)
        //data.attachments已经排好序了，不需要自己再排序
        if (attachments && attachments.length) {
          attachments.forEach((item) => {
            //item.picType 0：身份证   1：医师资格证   2：执业证    3：医师职称
            picSec[item.picType][item.page - 1] = item //item.page从1开始,代表身份证正面或者其他证件的第一页
          })
        }

        const state = {
          status: data.status >= 0 ? data.status : -1,
          rejectReason: data.rejectReason,
          diseaseCenterId: data.medicalId || centerId,
          diseaseCenterName: data.medicalName,
          diseaseTeamName: data.teamName,

          idCardFrontUrl: picSec[0][0] && picSec[0][0].url,
          idCardBackUrl: picSec[0][1] && picSec[0][1].url,
          docMedical1PicUrl: picSec[1][0] && picSec[1][0].url,
          docMedical2PicUrl: picSec[1][1] && picSec[1][1].url,
          docOperate1PicUrl: picSec[2][0] && picSec[2][0].url,
          docOperate2PicUrl: picSec[2][1] && picSec[2][1].url,
          docWorkPicUrl: picSec[3][0] && picSec[3][0].url,
        }

        commit(types.SAVE_IHAPPLYINFO, state)
        resolve(res)
      }else{
        resolve(res)
      }

    }, err => {
      reject(err)
    })
  })
}


// 微信跳转app获取微信配置信息
export const getconfigWxPromise = ({ dispatch, commit, state }) => {
  var apiurl = getJskUrl()
  var url = location.href.split('#')[0]
  const postData = {
    'head': {
      'auth': '',
      'auth2': '',
      'cid': '861010035174520',
      'cver': '9.7.14',
      'patientToken': null
    }
  }
  postData.head.auth = state.user.auth
  postData.url = url
  return new Promise((resolve, reject) => {
    httpPromise(apiurl, postData).then(res => {
      if (res && res.body) {
        var data = res.body || {}
        const state = {
          appId: data.appId || '',
          nonceStr:  data.nonceStr || '',
          signature: data.signature || '',
          timestamp: data.timestamp || '',
          url: data.url || ''
        }
        commit(types.SAVE_CONFIGWX_INFO, state)
        resolve(res)
      }
    })
  })
}


// 同步微信配置
export const syncWxInfo = (context, data) => {
  var res = data || {}
  const state = {
    appId: res.appId || '',
    nonceStr:  res.nonceStr || '',
    signature: res.signature || '',
    timestamp: res.timestamp || '',
    url: res.url || ''
  }
  context.commit(types.SAVE_CONFIGWX_INFO, state)
}
